import client from '../httpClient';

const sendmailTestApi = (params) => {
  return client.post('/send-mails/test', params, { isShowMessage: true, isShowLoading: false });
};

export default sendmailTestApi;
